import { APP_INITIALIZER, NgModule } from '@angular/core';
import { SeoService } from './providers/seo.service';
import { RECAPTCHA_V3_SITE_KEY } from "ng-recaptcha-2";

export function initializeApp(canonicalLinkService: SeoService): () => Promise<void> {
  return (): Promise<void> => canonicalLinkService.init();
}

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    SeoService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ SeoService ],
      multi: true
    },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: "6Lf3UdgsAAAAAL4SIFEG6jadNY8KGdBobX-LZVyZ" }
  ]
})
export class CoreModule {
}
